import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { DisplaySwitch, Flex } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';

export default function HistoricTabs({
  ilk,
  collateralSymbol,
  collateralAddress
}) {
  const [activeDisplayOption, setActiveDisplayOption] = useState('ink');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');

  const displayOptions = useMemo(
    () => [
      { key: 'ink', value: 'Locked' },
      { key: 'debt', value: 'Borrow' },
      // { key: 'weighted_cr', value: 'Weighted Collateral Ratio' },
      { key: 'total_exit_fees', value: 'Exit Fees' }
    ],
    []
  );

  const [data, error] = useApi({
    url: `/groups/core/ilks/${ilk}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  const [LSEdata, LSEerror] = useApi({
    url: `/lse/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error || LSEerror) {
    throw error;
  }

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  if (data && LSEdata) {
    const result = activeDisplayOption === 'total_exit_fees' ? LSEdata : data;
    return (
      <Flex flexDirection="column" gap="xs">
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />

        <HistoricGraphs
          data={result}
          type={activeDisplayOption}
          collateralSymbol={collateralSymbol}
          collateralAddress={collateralAddress}
          timeFilter={timeFilter}
          chartDaysAgo={chartDaysAgo}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
